<template>
  <a-modal
    :visible="visible"
    width="576px"
    class="instructions"
    @cancel="handleCancel"
    :footer="null"
    centered
  >
    <div>
      <img :src="configInst.icon" width="64" alt="Google Auth" />
    </div>
    <h2 class="instructions_title">
      {{ configInst.title }}
    </h2>

    <div class="instructions_list">
      <p>
        Antes de empezar, ten en cuenta las siguientes consideraciones:
      </p>
      <h4>Consideraciones:</h4>
      <div>
        <div
          v-for="(item, key) in configInst.list"
          :key="key"
          class="instructions_list--item">
          <div style="">
            <component :is="item.icon" style="width: 20px; font-size: 18px; color: #000000A6; margin-top: 2px" />
          </div>
          <div>
            {{ item.text }}
          </div>
        </div>
      </div>

      <a-button
        class="button"
        type="primary"
        @click="
          emit('next');
          emit('update:visible', false);
        "
      >
        Continuar
      </a-button>
      <span class="info" v-if="mfaType == MfaType.Google">
        Para mayor información.
        <a target="_blank" :href="urlGoogleAuth">
          Leer más sobre Google Authenticator
          <ImportOutlined />
        </a>
      </span>
    </div>
  </a-modal>
</template>

<script lang="ts" setup>
import { MfaType } from '@/app/auth/utils/enums';
import { ImportOutlined, LockOutlined, MailOutlined, SyncOutlined, UserAddOutlined } from '@ant-design/icons-vue';
import { computed } from 'vue'
import googleAuth from "@/app/auth/assets/google_auth.png?url";
import mailIcon from "@/app/auth/assets/mail_icon.png?url";
import IconCellphone from '@/app/common/components/atoms/IconCellphone.vue';
const urlGoogleAuth = import.meta.env.VITE_GOOGLE_AUTH_TUTORIAL;

const props = defineProps<{
  visible: boolean,
  mfaType: MfaType | null,
}>()

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void
  (e: 'next'): void
}>()

const instructions = {
  [MfaType.Google]: {
    title: "Autenticación en 2 pasos con Google Authenticator",
    icon: googleAuth,
    list: [
      {
        icon: IconCellphone,
        text: `Todos los roles que se asignen a esta autenticación, 
          deberán descargar la aplicación Google Authenticator en 
          su dispositivo móvil o tablet, para escanear el código QR.`,
      },
      {
        icon: UserAddOutlined,
        text: `Para iniciar sesión en la aplicación, se puede acceder con o 
          sin cuenta de Google.`,
      },
      {
        icon: LockOutlined,
        text: `Desde Google Authenticator, obtendrás códigos dinámicos 
          de verificación cada 30 segundos, que te permitirán iniciar 
          sesión en BeexCC.`,
      },
    ]
  },
  [MfaType.Email]: {
    title: "Autenticación en 2 pasos con correo electrónico",
    icon: mailIcon,
    list: [
      {
        icon: MailOutlined,
        text: `Todos los roles que se asignen a esta autenticación, 
          deberán asegurarse de ingresar un correo válido para el 
          envío del código de verificación.`,
      },
      {
        icon: SyncOutlined,
        text: `Si se ingresa un correo nuevo, este reemplazará al actual 
          con el que se accede en BeexCC.`,
      },
      {
        icon: LockOutlined,
        text: `En cada inicio de sesión, se enviará un código de 
          verificación de 6 dígitos al correo registrado previamente.`,
      },
    ]
  }
}

const configInst = computed(() => {
  return instructions[props.mfaType as MfaType];
});

const handleCancel = () => {
  emit("update:visible", false);
}
</script>

<style scoped lang="sass">
.text-secondary
  color: #888

.mb-4
  margin-bottom: 1rem

.modal
  &_title
    width: 100%
    text-align: center
  &_subtitle
    font-weight: 600

.options_roles
  width: 100%
  .option_role
    width: 100%
    margin-bottom: 12px
    :deep(.ant-card-body)
      padding: 12px
      border-radius: 0 0 10px 10px

.expiration_inputs
  display: flex
  justify-content: center
  margin-top: 24px
  margin-bottom: 100px
  :deep(.ant-card-body)
    padding: 12px

  form
    align-items: center

:global(.instructions .ant-modal-body)
  text-align: center !important
  padding: 20px 50px

.instructions
  &_title
    margin: 20px 40px
  &_list
    text-align: left
    h4
      margin-bottom: 12px
    &--item
      display: flex
      gap: 5px
    > div
      display: flex
      flex-direction: column
      gap: 10px

.button
  width: 100%
  margin: 20px 0

</style>
